<template>
  <div class="record mainWrap">
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/EF001"></leftNav>
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-container>
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
          <el-main style="height:100%">
            <div class="mainWrao">
              <div class="recordTitle">
                <h1>{{$t('leftNav.navSeven1')}}</h1>
                <div style="float:right;display:flex;align-items: center;">
                  <label style="margin-right:10px;font-size:12px;">{{$t('EventRecord.condition1')}}</label>
                  <equipment @change="getchange" class="machinevue" :machine="Number(machineId)" :show="true"></equipment>
                </div>
              </div>
              <!-- 表格部分 -->
              <div class="tableWrap">
                <el-row class="titleRow" v-loading="seachLoading">
                  <el-col :span="5">
                    <label>{{$t('EventRecord.condition2')}}</label>
                    <el-select v-model="eventCode" class="selectGroup" clearable :placeholder="$t('EventRecord.selectPlacehoder')" @change="changeLine">
                      <el-option
                        v-for="item in eventCodes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="5">
                    <label>{{$t('EventRecord.condition3')}}</label>
                    <el-select v-model="typeId" class="selectGroup" clearable :placeholder="$t('EventRecord.selectPlacehoder')" @change="changeLine">
                      <el-option
                        v-for="item in types"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="5">
                    <label>{{$t('EventRecord.condition4')}}</label>
                    <el-select v-model="groupId" class="selectGroup" clearable :placeholder="$t('EventRecord.selectPlacehoder')" @change="changeLine">
                      <el-option
                        v-for="item in groups"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4">
                    <label>{{$t('EventRecord.condition5')}}</label>
                    <el-select v-model="emId" class="selectGroup" clearable :placeholder="$t('EventRecord.selectPlacehoder')" @change="changeLine">
                      <el-option
                        v-for="item in ems"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>                    
                    </el-select>
                  </el-col>
                  <el-col :span="5">
                    <label>{{$t('EventRecord.condition6')}}</label>
                    <el-select  v-if="$store.state.lang !== 1" v-model="duration" class="selectGroup" clearable :placeholder="$t('EventRecord.selectPlacehoder')" @change="changeLine">
                      <el-option label="all" value="1"></el-option>
                      <el-option label="<1′" value="2"></el-option>
                      <el-option label="1′~10′" value="3"></el-option>
                      <el-option label="10′~30′" value="4"></el-option>
                      <el-option label="30′~1h" value="5"></el-option>
                      <el-option label="1h" value="6"></el-option>
                    </el-select>
                    <el-select v-if="$store.state.lang===1" v-model="duration" class="selectGroup" clearable :placeholder="$t('EventRecord.selectPlacehoder')" @change="changeLine">
                      <el-option label="全部" value="1"></el-option>
                      <el-option label="<1分钟" value="2"></el-option>
                      <el-option label="1分钟~10分钟" value="3"></el-option>
                      <el-option label="10分钟~30分钟" value="4"></el-option>
                      <el-option label="30分钟~1小时" value="5"></el-option>
                      <el-option label=">1小时" value="6"></el-option>                
                    </el-select>
                  </el-col>
                </el-row>
                <!-- 时间 -->
                <div class="datePick">
                  <span style="color:red;font-size:20px;margin:10px 10px 0 0;">*</span>
                  <el-date-picker
                    v-model="selectTime"
                    type="datetimerange"
                    :start-placeholder="$t('EventRecord.timeStart')"
                    :end-placeholder="$t('EventRecord.timeEnd')"
                    @change="changeTimes">
                  </el-date-picker>
                  <div class="btns">
                    <el-button size="small" @click="btn_clean">{{$t('EventRecord.Clean')}}</el-button>
                    <el-button type="primary" size="small" icon="el-icon-search" @click="getEventRecordList()">{{$t('EventRecord.Search')}}</el-button>
                    <el-button size="small" v-show="this.$store.state.authority.PageDownload.show" @click="btn_export" style="vertical-align:bottom; padding:7px 15px;"><downloadIcon style="font-size:14px;" title=""/> {{$t('EventRecord.Export')}}</el-button>
                  </div>
                </div>
                 <!-- 两个 柱形图 -->
                 <div  class="chartWrap">
                   <div  id="myChart"></div>
                   <div   id="myChart2"></div>
                 </div>
                <!-- 表格 -->
                <el-table
                  v-loading="loading"
                  :data="tableData"
                  style="width: 100%"
                  :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')"
                  @sort-change="highSeaOrder">
                  <el-table-column
                    :label="$t('EventRecord.tableTitle1')"
                    width="160">
                    <template slot-scope="scope">
                      <span v-if="$store.state.lang===1">{{scope.row.equipmentName}}{{"(" + scope.row.machineNameZh + ")"}}</span>
                      <span v-else>{{scope.row.equipmentName}}{{"(" + scope.row.machineNameEn + ")"}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="msgCode"
                    :label="$t('EventRecord.tableTitle2')"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    :label="$t('EventRecord.tableTitle3')"
                    min-width="220">
                     <template slot-scope="scope">
                      <span v-if="$store.state.lang===1">{{scope.row.event}}</span>
                      <span v-else>{{scope.row.msgEn}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="group"
                    :label="$t('EventRecord.tableTitle4')"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="em"
                    :label="$t('EventRecord.tableTitle5')"
                    width="80">
                  </el-table-column>
                  <!-- 表格中带图标的部分 -->
                  <el-table-column
                    :label="$t('EventRecord.tableTitle6')"
                    width="110">
                    <template slot-scope="scope">
                      <helpIcon style="color:#808080" v-if="scope.row.typeValue === 'MCOND'" class="typeIcon" title="" />
                      <messageIcon style="color:#7948ea;" v-else-if="scope.row.typeValue === 'INFO'" title="" class="typeIcon"/>
                      <alertIcon style="color:#f16a4d" v-else-if="scope.row.typeValue === 'ALM'" title="" class="typeIcon"/>
                      <closeIcon style="color:#d43030;" v-else-if="scope.row.typeValue === 'FLT'" title="" class="typeIcon"/>
                      <span style="margin-left: 10px" :class="{mcond: scope.row.typeValue === 'MCOND', info:scope.row.typeValue === 'INFO', alm:scope.row.typeValue === 'ALM',flt:scope.row.typeValue === 'FLT'}">{{ scope.row.typeValue }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="timeStamp"
                    :label="$t('EventRecord.tableTitle7')"
                    width="180"
                    sortable="custom">
                    <template slot-scope="scope">
                      <span>{{ scope.row.createTime | formatDate }}</span>
                    </template>
                  </el-table-column>

                   <el-table-column
                    prop="timeStamp"
                    :label="$t('EventRecord.tableTitle9')"
                    width="180"
                    sortable="custom">
                    <template slot-scope="scope">
                      <span>{{ scope.row.updateTime | formatDate }}</span>
                    </template>
                  </el-table-column>
                  
                  <el-table-column
                    :label="$t('EventRecord.tableTitle8')"
                    width="90"
                    align='center'>
                    <template slot-scope="scope" >
                      <span v-if="scope.row.updateTime !== null">
                        {{scope.row.duration}}''
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- 分页 -->
              <el-pagination
                class="pagination"
                background
                layout="prev, pager, next"
                :total="listTotal"
                :current-page.sync="nowPage"
                @current-change="handleCurrentChange"
                @size-change="handleCurrentSizeChange">
              </el-pagination>
            </div>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
  </div>
</template>

<script>

import { formatDate } from '../assets/js/date.js'
import leftNav from "@/components/nav.vue"
import helpIcon from "vue-material-design-icons/HelpCircle.vue"
import messageIcon from "vue-material-design-icons/MessageAlert.vue"
import alertIcon from "vue-material-design-icons/Alert.vue"
import closeIcon from "vue-material-design-icons/CloseCircle.vue"
import downloadIcon from "vue-material-design-icons/Download.vue"
import equipment from "@/components/Equipment.vue"
export default {
  name: 'record',
  components: {
    leftNav,
    helpIcon,
    messageIcon,
    alertIcon,
    closeIcon,
    downloadIcon,
    equipment
  },
  data () {
    return {
      // 图表
      barChart: null,
      barChart2: null,
      // Machine筛选条件
      condition1: null,
      // EventCode筛选条件
      eventCode: '',
      // type筛选条件
      typeId: '',
      // Group筛选条件
      groupId: '',
      // EM筛选条件
      emId: '',
      // 排序
      sort: '',
      // 筛选时间
      selectTime: [],
      startTime: '',
      endTime: '',
      types: [],
      eventCodes: [],
      groups: [],
      ems: [],
      Machines: [],
      factoryId: '',
      machineId: '',
      machineName: '',
      shopId: '',
      lineId: '',
      duration: '',
      // *********当前页数
      nowPage: 1,
      nowPageSize: 10,
      listTotal: null,
      // 表格数据
      tableData: [],
      // fal数据
      faultData: [],
      // alm数据
      alarmData: [],
      loading: true,
      seachLoading: false,
      // 时间快捷键
      pickerMinDate: '',

      // 七天日期选择
      // pickerOptions: {
      //   onPick: ({minDate}) => {
      //       this.pickerMinDate = minDate.getTime()
      //     },
      //     disabledDate: (time) =>{
      //       if (this.pickerMinDate !== '') {
      //         const day7 = 7 * 24 * 3600 * 1000
      //         let maxTime = this.pickerMinDate + day7
      //         let minTime = this.pickerMinDate - day7
      //         return (time.getTime() > maxTime ||
      //                   time.getTime() < minTime)
      //       } else {
      //         return ''
      //       }
      //     },
      //   shortcuts: [{
      //     text: this.$t('EventRecord.pickTime1'),
      //     onClick(picker) {
      //       const end = new Date();
      //       const start = new Date();
      //       start.setTime(start.getTime() - 3600 * 1000 * 4);
      //       picker.$emit('pick', [start, end]);
      //     }
      //   }, {
      //     text: this.$t('EventRecord.pickTime2'),
      //     onClick(picker) {
      //       const end = new Date();
      //       const start = new Date();
      //       start.setTime(start.getTime() - 3600 * 1000 * 8);
      //       picker.$emit('pick', [start, end]);
      //     }
      //   }]
      // }
      // 点了查询之后才会改变的值，用在导出的赋值上
      dlmachineId:'',
      dleventCode:'',
      dltypeId:'',
      dlgroupId:'',
      dlemId:'',
      dlduration:'',
      dlstartTime:'',
      dlendTime:'',
      // 是不是第一次进来
      index:0
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    }
  },
   beforeMount(){
    this.$store.commit('toLogin')
  },
  created(){
    // 获取初始时间（一周的数据）
    this.getWeeksData()
  },
  mounted() {
    this.$store.commit('authority' , this.$route.path)
    
     if (this.$route.params.factoryId != null && this.$route.params.factoryId != 'undefined') {
      this.condition1 = [this.$route.params.factoryId, this.$route.params.machineId]
      this.factoryId = this.$route.params.factoryId
      this.machineId = this.$route.params.machineId
      this.machineName = this.$route.params.machineName
      this.getEventRecordList ()
      this.chartResize()
      this.getEventData()
    }else {
      if (this.$store.state.reloadState === false) {
            this.$store.state.reloadState = true
            this.$parent.reload()
          }else{
            this.getEventData()
            this.condition1 = [Number(this.$store.state.defaultFactoryId), Number(this.$store.state.defaultId)]
            this.factoryId = Number(this.$store.state.defaultFactoryId)
            this.machineId =  Number(this.$store.state.defaultId)
            this.typeId = 39
            this.getEventRecordList ()
            this.chartResize()
      }
    }
    if (localStorage.getItem('isMarketAccount') === '1') {
      this.condition1 = [2, 101]
      this.factoryId = '2'
      this.machineId = '101'
      this.getEventRecordList ()
      this.chartResize()
    }
  },
  destroyed() {
    clearInterval(this.resizeTimer)
  },
  methods: {
    // 切换设备
    getchange(value){
      this.condition1[1]=value
      this.machineId=value
      this.changeMachines()
    },
     highSeaOrder (column) {
      if (column.prop) {
        if (column.order === 'ascending') {
          this.sort = ''
        } else {
          this.sort = 'asc'
        }
      } else {
        this.sort = ''
      }
      this.getEventRecordList()
    },
    changeLine () {
      this.selectChooseManiceLog()
    },
    // 获取初始化时间（一周的数据）
    getWeeksData(){
      let initializeDateTime = new Date()
      let tYear = initializeDateTime.getFullYear();
      let tMonth = initializeDateTime.getMonth()+1;
      let tDate = initializeDateTime.getDate();

      let startDate1 = new Date(`${tYear}/${tMonth}/${tDate} 00:00:00`)
      let endDate = new Date(`${tYear}/${tMonth}/${tDate} 23:59:59`)
      let startChuo = startDate1.getTime()-86400000*6
      let startDate = new Date(startChuo)
      let startYear = startDate.getFullYear();
      let startMonth = startDate.getMonth()+1;
      let startD = startDate.getDate();

      this.selectTime = [startDate,endDate]
      this.startTime =`${startYear}-${startMonth}-${startD} 00:00:00`
      this.endTime = `${tYear}-${tMonth}-${tDate} 23:59:59`
    },
    changeMachines () {
      if (this.condition1 != '' && this.condition1 != null) {
        if (this.condition1.length === 2) {
          this.lineId = ''
          this.machineId = this.condition1[1]
          this.shopId = ''
          this.factoryId = ''
        }
        if (this.condition1.length === 1) {
          this.lineId = ''
          this.machineId = ''
          this.shopId = ''
          this.factoryId = this.condition1[0]
        }
      }
      this.eventCode = ''
      this.typeId = 39
      this.groupId = ''
      this.emId = ''
      this.duration = ''
      this.index=0
      this.getWeeksData()
      this.getEventData()
    },
    changeTimes () {
      if (this.selectTime != '' && this.selectTime != null) {
        this.startTime = formatDate(new Date(this.selectTime[0]), 'yyyy-MM-dd hh:mm:ss')
        this.endTime =  formatDate(new Date(this.selectTime[1]), 'yyyy-MM-dd hh:mm:ss')
      } else {
        this.startTime = ''
        this.endTime = ''
        this.pickerMinDate = ''
      }
      this.getEventData()
    },
    // 列表查询
    getEventRecord () {
      let _this = this
      this.axios({
        method: 'post',
        url: '/download/selectFaultAlarmQuery',
        params: {
          pageNum: _this.nowPage,
          pageSize: _this.nowPageSize,
          factoryId: _this.factoryId,// 工厂的id
          machineId: _this.machineId, // 机器的id
          typeId: _this.typeId, // Type类型id
          groupId: _this.groupId, // Group的id
          emId: _this.emId, // EM的id
          duration: _this.duration,// 处理时间
          eventCode: _this.eventCode, // EventCode值
          startTime: _this.startTime, // 开始时间
          endTime: _this.endTime, // 结束时间
          sort: _this.sort
        }
      }).then(function (res) {
        _this.tableData = res.data.rows
        _this.listTotal = res.data.total
        if (res.data.faultData != null) {
          document.getElementById("myChart").style.display="inline"
          _this.faultData = res.data.faultData
        }else {
          _this.faultData = null
          document.getElementById("myChart").style.display = "none"
        }
        if (res.data.alarmData != null) {
          document.getElementById("myChart2").style.display="inline"
          _this.alarmData = res.data.alarmData
        }else {
          _this.alarmData = null
          document.getElementById("myChart2").style.display = "none"
        }
        _this.initChart()
        _this.initChart2()
        _this.loading = false
      }).catch(function () {
        _this.loading = false
      })
    },
    // 获取警告各种基础数据
    getEventData () {
      let _this = this
      this.seachLoading = true
      this.axios({
        method: 'get',
        url: '/url/selectChooseManice',
        params:{
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          if(localStorage.getItem('isMarketAccount') === '1') {
            _this.$store.commit('marketAccount',res.data.options)
          }
          _this.Machines = res.data.options
          if (_this.$route.params.factoryId != null && _this.$route.params.factoryId != 'undefined') {
            var machineIds
            if (_this.Machines.length > 1) {
              machineIds = res.data.options[_this.$route.params.factoryId - 1]
            }else{
              machineIds = res.data.options[0]
            }
              var machineIdIsNO = true
              for (var j = 0; j < machineIds.children.length;j++) {
                if(machineIds.children[j].value == _this.machineId || _this.machineId=='') {
                    machineIdIsNO = true
                    break 
                }else{ 
                    machineIdIsNO = false 
                }
              }
              if (!machineIdIsNO) {
                _this.$message.error(_this.machineName +' '+ _this.$t('EventRecord.machinesError'));
              }
          }          
        } else {
          _this.$message.error('Machine list loading failed')
        }
        _this.selectChooseManiceLog ()
        _this.seachLoading = false
      })
    },
    selectChooseManiceLog () {
      let _this = this
      this.axios({
        method: 'GET',
        url: '/download/selectChooseManiceLog',
        params: {
          language: _this.$store.state.lang,
          factoryId: _this.factoryId,// 工厂的id
          machineId: _this.machineId, // 机器的id
          typeId: _this.typeId, // Type类型id
          groupId: _this.groupId, // Group的id
          emId: _this.emId, // EM的id
          eventCode: _this.eventCode, // EventCode值
          startDate: _this.startTime,
          endDate: _this.endTime
        }
      }).then(function (res) {
        if (res.data.types !== undefined) {
          _this.types = res.data.types
          if(_this.index==0 && res.data.types.length == 0) _this.typeId=''
        }
        if (res.data.eventCodes !== undefined) {
          _this.eventCodes = res.data.eventCodes
        }
        if (res.data.groups !== undefined) {
          _this.groups = res.data.groups
        }
        if (res.data.ems !== undefined) {
          _this.ems = res.data.ems
        }
        _this.index=1
      })
    },
    getEventRecordList() {
       if (this.startTime == '' && this.endTime == '') {
        this.$message.error(this.$t('EventRecord.selectTimeError'))
        return
      }
      this.nowPage = 1
      this.loading = true
      localStorage.setItem("typeId", this.typeId)
      localStorage.setItem("startTime", this.startTime)
      localStorage.setItem("endTime", this.endTime)
      localStorage.setItem("eventCode", this.eventCode)
      localStorage.setItem("groupId", this.groupId)
      localStorage.setItem("emId", this.emId)
      localStorage.setItem("duration", this.duration)
      localStorage.setItem("machineId", this.machineId)
      this.dlmachineId= this.machineId
      this.dleventCode=this.eventCode
      this.dltypeId=this.typeId
      this.dlgroupId=this.groupId
      this.dlemId=this.emId
      this.dlduration=this.duration
      this.dlstartTime=this.startTime
      this.dlendTime=this.endTime
      this.getEventRecord()
    },
    getEventRecordListPage () { 
      this.loading = true
      this.typeId = Number(localStorage.getItem("typeId"))?Number(localStorage.getItem("typeId")):''
      this.startTime = localStorage.getItem("startTime")
      this.endTime = localStorage.getItem("endTime")
      this.eventCode = localStorage.getItem("eventCode")
      this.groupId = Number(localStorage.getItem("groupId"))?Number(localStorage.getItem("groupId")):''
      this.emId = Number(localStorage.getItem("emId"))?Number(localStorage.getItem("emId")):''
      this.duration = localStorage.getItem("duration")
      this.machineId=localStorage.getItem("machineId")
      this.startDate =  formatDate(new Date(this.startTime), 'yyyy-MM-dd hh:mm:ss')
      this.endDate =  formatDate(new Date(this.endTime), 'yyyy-MM-dd hh:mm:ss')
      this.selectTime = [this.startDate,this.endDate]
      this.getEventRecord()
    },
    // 分页
    handleCurrentChange (val) {
      this.nowPage = val
      this.getEventRecordListPage()
    },
    handleCurrentSizeChange (val) {
      this.nowPageSize = val
      this.getEventRecordList()
    },
    // 清除功能
    btn_clean () {
      this.machineId=''
      this.typeId = ''
      this.selectTime = []
      this.startTime = ''
      this.endTime = ''
      this.eventCode = ''
      this.groupId = ''
      this.emId = ''
      this.shopId = ''
      this.lineId = ''
      this.duration = ''
      this.nowPage = 1
      this.nowPageSize = 10
      this.getEventData ()
    },
    // 导出功能
    btn_export () {
      if(this.tableData== undefined || this.tableData.length <= 0){
        this.$message.error(this.$t('gantt.error'));
      }else{
        let signTime = new Date().getTime()
        this.$store.commit('nowsign', signTime)
        this.urlData = '?factoryId=' + this.factoryId + '&shopId=' + this.shopId + '&lineId=' + this.lineId + '&machineId=' + this.dlmachineId + '&typeId=' + this.dltypeId + '&groupId=' + this.dlgroupId + '&emId=' + this.dlemId  + '&duration=' + this.dlduration + '&eventCode=' + this.dleventCode + '&startTime=' + this.dlstartTime + '&endTime=' + this.dlendTime + '&sort=' + this.sort + '&language=' + this.$store.state.lang+'&sign='+this.$store.state.sign + '&auth_Code='+this.$store.state.authCode+'&sign_time='+signTime+'&route='+this.$store.state.newroute+'&factory_id='+this.$store.state.factoryId
        window.open('/download/exportLog' + this.urlData, '_blank')
      }
    },
    // 图表初始化
    initChart(){
      let _this = this
      _this.codeArr = []
      _this.desArr = []
      _this.numArr = []
      for (const item of _this.faultData) {
        _this.codeArr.push(item.msgCode)
        _this.numArr.push(item.codeNum)
        if (this.$store.state.lang === 1) {
          _this.desArr.push(item.group + '-' + item.em +'-' + item.event)
        }else {
         if (item.msgEn !=null ){
            _this.desArr.push(item.group + '-' + item.em +'-' + item.msgEn)
          }else{
            _this.desArr.push(item.group + '-' + item.em )
          }  
        }
      }
      let timeTitle = ''
      if (this.selectTime != '' && this.selectTime != null) {
        let startTime = formatDate(new Date(this.selectTime[0]), 'yyyy-MM-dd hh:mm:ss')
        let endTime =  formatDate(new Date(this.selectTime[1]), 'yyyy-MM-dd hh:mm:ss')
        timeTitle = `${startTime} ~ ${endTime}`
        }
      this.barChart = this.$echarts.init(document.getElementById('myChart'))
      this.barChart.setOption({
          title: {
          text: _this.$t('EventRecord.chartTitle'),
          subtext: timeTitle
      },
      tooltip: {
          trigger: 'axis',
          axisPointer: {
              type: 'shadow'
          },
          formatter:function(params){
            let titleIndex = params[0].dataIndex
            let titleArr =  params[0].seriesName.split(',')
            
            return params[0].axisValue + '<br/>' +
                        titleArr[titleIndex] + ' : ' +
                        params[0].data
          }
      },
      grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
      },
      xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
      },
      yAxis: {
          type: 'category',
          data: _this.codeArr
      },
      series: [
          {
              name: _this.desArr,
              type: 'bar',
              itemStyle: {
                    normal: {color: '#085ba6'}
              },
              data: _this.numArr
          }
        ]
      })
    },
    initChart2(){
      let _this = this
      _this.codeArr = []
      _this.desArr = []
      _this.numArr = []
      for (const item of _this.alarmData) {
        _this.codeArr.push(item.msgCode)
        _this.numArr.push(item.codeNum)
         if (this.$store.state.lang === 1) {
          _this.desArr.push(item.group + '-' + item.em +'-' + item.event)
        }else {
          if (item.msgEn !== null ){
            _this.desArr.push(item.group + '-' + item.em +'-' + item.msgEn)
          }else{
            _this.desArr.push(item.group + '-' + item.em)
          }  
        }
      }
      let timeTitle = ''
      if (this.selectTime != '' && this.selectTime != null) {
        let startTime = formatDate(new Date(this.selectTime[0]), 'yyyy-MM-dd hh:mm:ss')
        let endTime =  formatDate(new Date(this.selectTime[1]), 'yyyy-MM-dd hh:mm:ss')
        timeTitle = `${startTime} ~ ${endTime}`
        }
      this.barChart2 = this.$echarts.init(document.getElementById('myChart2'))
      this.barChart2.setOption({
          title: {
          text: _this.$t('EventRecord.chartTitle2'),
          subtext: timeTitle
      },
      tooltip: {
          trigger: 'axis',
          axisPointer: {
              type: 'shadow'
          },
          formatter:function(params){
            let titleIndex = params[0].dataIndex
            let titleArr =  params[0].seriesName.split(',')
            
            return params[0].axisValue + '<br/>' +
                        titleArr[titleIndex] + ' : ' +
                        params[0].data
          }
      },
      grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
      },
      xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
      },
      yAxis: {
          type: 'category',
          data: _this.codeArr
      },
      series: [
          {
              name: _this.desArr,
              type: 'bar',
              itemStyle: {
                    normal: {color: '#085ba6'}
              },
              data: _this.numArr
          }
        ]
      })
    },
    // 图表自动修正大小
    chartResize(){
      let _this = this
      this.resizeTimer = setInterval(function(){
        if (_this.barChart !== null && _this.barChart2 !== null) {
          _this.barChart.resize()
          _this.barChart2.resize()
        }
      },500)
    }
  },
  filters: {
    formatDate (time) {
      if (time === null || time === '') {
        return ''
      }
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  },
}
</script>
<style scoped>
.machineWrap{
  min-width: 1080px;
}
.record{
  height: 100%;
}
.mainWrao{
  min-width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  padding-bottom: 35px;
  border-radius: 4px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  display: inline-block;
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
}
.recordTitle div a {
  margin-left: 20px;
  color: #6bb4df;
}
.selectGroup{
  width: 105px;
}
.tableWrap{
  padding: 25px 30px;
}
.titleRow label{
  font-size: 12px;
}
.datePick{
  margin: 25px 0;
}
.datePick .btns{
  float: right;
}
.typeIcon{
  color: #6772e5;
}
.pagination{
  text-align: center;
  margin-top: 35px;
}
.mcond{
  color:#808080
}
.info{
  color:#7948ea;
}
.alm{
  color:#f16a4d
}
.flt{
  color:#d43030;
}
.chartWrap{
  width: 100%;
  display: flex;
  margin: 15px 0;
}
.chartWrap div{
  width: 50%;
  height: 200px;
  margin: 0 5%;
}
</style>

